<aw-section [testIdAffix]="id()">
  <div class="flex flex-col items-center">
    <div class="w-full pb-4 text-3xl">
      {{ card().controls.title.value | language }}
    </div>
    <div class="flex w-full flex-row items-center">
      <div class="flex w-2/12 justify-start">
        @if (cardIndex() > 0) {
          <span
            [attr.data-testid]="'arrow-left-logo-' + cardIndex()"
            class="material-symbols-rounded cursor-pointer"
            (click)="
              moveItemAtIndex(
                sectionForm().controls.tiles,
                cardIndex(),
                cardIndex() - 1
              )
            ">
            keyboard_arrow_left
          </span>
        }
      </div>
      <div class="flex w-8/12 w-full max-w-8/12 flex-col gap-4 text-center">
        <aw-button
          (click)="
            router.navigate(
              [
                ERoute.edit,
                sectionForm().controls.id.value,
                card().controls.id.value,
              ],
              { relativeTo: route }
            )
          "
          [isDisabled]="!card().controls.id.value"
          [style]="'primary'"
          [text]="cmsTextProvider.customTiles.edit"
          id="customize"
          type="submit">
          <span class="material-symbols-rounded pr-2">edit</span>
        </aw-button>
        <aw-button
          (click)="deleteCard()"
          [isDisabled]="deactivateDeleteCard()"
          [style]="'error-alt'"
          id="delete"
          type="submit">
          <span class="flex max-w-full flex-row items-center overflow-hidden">
            @if (deactivateDeleteCard()) {
              <span class="material-symbols-rounded pr-2">lock</span>
            } @else {
              <span class="material-symbols-rounded pr-2">delete</span>
            }
            <div class="max-w-10/12 break-words">
              {{
                deactivateDeleteCard()
                  ? cmsTextProvider.customTiles.cannotRemoveTile
                  : cmsTextProvider.shared.delete
              }}
            </div>
          </span>
        </aw-button>
      </div>
      <div class="flex w-2/12 justify-end">
        @if (cardIndex() < sectionForm().controls.tiles.length - 1) {
          <span
            [attr.data-testid]="'arrow-right-logo-' + cardIndex()"
            class="material-symbols-rounded cursor-pointer"
            (click)="
              moveItemAtIndex(
                sectionForm().controls.tiles,
                cardIndex(),
                cardIndex() + 1
              )
            ">
            keyboard_arrow_right
          </span>
        }
      </div>
    </div>
  </div>
</aw-section>
